import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { CustomerListItem } from '../models/customer-list-item';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';

export const CUSTOMER_LIST_FETCH = 'CUSTOMER_LIST_FETCH';
export const CUSTOMER_LIST_RECEIVE = 'CUSTOMER_LIST_RECEIVE';
export const CUSTOMER_LIST_FETCH_FAILED = 'CUSTOMER_LIST_FETCH_FAILED';

export const receiveCustomerList = (customers: PaginatedResponse<CustomerListItem>) => {
    return {
        type: CUSTOMER_LIST_RECEIVE,
        customers,
    };
};

export const fetchCustomerList = (searchParams: URLSearchParams) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CUSTOMER_LIST_FETCH });
        const response = await api.contactsAndOrganizations.Customer.CustomerList.getCustomers(searchParams);
        if (response.success) {
            dispatch(receiveCustomerList(response.result));
        } else {
            dispatch({ type: CUSTOMER_LIST_FETCH_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
